import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { faTimes, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { RefundsService } from 'src/app/services/refunds.service';
import { DialogFeedbackComponent } from '../dialog-feedback/dialog-feedback.component';

@Component({
  selector: 'app-dialog-refund-confirm',
  templateUrl: './dialog-refund-confirm.component.html',
  styleUrls: ['./dialog-refund-confirm.component.scss']
})
export class DialogRefundConfirmComponent {

  faTriangleExclamation = faTriangleExclamation;
  faTimes = faTimes;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, private refundsService: RefundsService) { }

  refundOrder() {
    if (this.data) {
      this.refundsService.refundOrder(this.data.id, {}, this.data.work_time).subscribe({
        next: (data: any) => {
          this.closeDialog();
          this.refundsService.setFilters(null, null, null, null);
          const dialogRef = this.dialog.open(DialogFeedbackComponent, {
            width: '650px',
            panelClass: 'rounded-dialog',
            data: {
              title: 'Devolución realizada',
              type: 'ok'
            }
          })
        }, error: (error) => {

          const dialogRef = this.dialog.open(DialogFeedbackComponent, {
            width: '650px',
            panelClass: 'rounded-dialog',
            data: {
              title: 'Error al realizar la devolución',
              subtitle: 'Ha ocurrido un error al realizar la devolución, por favor intenta nuevamente.',
              type: 'error'
            }
          })
        }
      });
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
